import posthog from "posthog-js";
import { setPosthogInstance } from "./posthogInstance"

export const posthogConfig = {
  api_host: "https://us.i.posthog.com",
  capture_pageview: false,
  autocapture: false,
  capture_pageleave: false,
  session_recording: false,
  capture_performance: false,
  capture_performance_navigation: false,
}

export default {
  install(app, options) {
    if (__ENV__ != "production" && !__POSTHOG_ENABLED__) {
      const emptyFn = () => {}
      app.config.globalProperties.$posthog = {};
      app.config.globalProperties.$posthogCapture = emptyFn;
      setPosthogInstance({}, emptyFn)
      return;
    }

    const { defaultParams } = options || {};

    const posthogInstance = posthog.__loaded
      ? posthog
      : posthog.init(__POSTHOG_TOKEN__, posthogConfig);

    const captureFn = (event, props) => {
      posthogInstance.capture(event, { ...defaultParams, ...props })
    }

    app.config.globalProperties.$posthog = posthogInstance
    app.config.globalProperties.$posthogCapture = captureFn
    setPosthogInstance(posthogInstance, captureFn)
  },
};
